import React, {Fragment} from "react";

import {compact} from "@pg-mono/nodash";

import {IValueLabel} from "../../../variables/types/IValueLabel";
import {findVariableByValue} from "../../../variables/utils/find_variable_by_value";

interface IProps {
    facilities: number[];
    facilitiesTypes: IValueLabel[];
}

export const OfferDetailFacilities = (props: IProps) => {
    const foundFacilitiesTypes = compact(props.facilities.map((facility) => findVariableByValue(props.facilitiesTypes, facility)));

    return <Fragment>{foundFacilitiesTypes.map(({label}) => label).join(", ")}</Fragment>;
};
import React, {Fragment} from "react";

import {compact} from "@pg-mono/nodash";

import {IValueLabel} from "../../../variables/types/IValueLabel";
import {findVariableByValue} from "../../../variables/utils/find_variable_by_value";

interface IProps {
    facilities: number[];
    facilitiesTypes: IValueLabel[];
}

export const OfferDetailFacilities = (props: IProps) => {
    const foundFacilitiesTypes = compact(props.facilities.map((facility) => findVariableByValue(props.facilitiesTypes, facility)));

    return <Fragment>{foundFacilitiesTypes.map(({label}) => label).join(", ")}</Fragment>;
};
